module.exports = __webpack_public_path__ + "static/media/logo_tpbank.74734e13.svg";